module.exports = __webpack_public_path__ + "img/logo-sm.9c95f53f.png";